import { addGenericErrorToast, addToast } from 'core/notifications';
import i18n from 'i18next';

export default async (value) => {
  try {
    await navigator.clipboard.writeText(value);
  } catch {
    return addGenericErrorToast();
  }

  addToast(i18n.t('copied-to-clipboard'), 'success');
};
